<div class="modal-header qep-header">
  <div>
    <h6 class="modal-title mb-0">
      Email {{ label }} <span class="qep-number">{{ doc?.number || '' }}</span>
    </h6>
    <small class="qep-customer" *ngIf="customer?.cName">{{ customer?.cName }}</small>
  </div>
  <div class="d-flex align-items-center gap-2">
    <span *ngIf="doc?.status" class="badge qep-status" [class.qep-status-draft]="canSendFromStatus" [class.qep-status-sent]="!canSendFromStatus">
      {{ statusLabel(doc?.status) }}
    </span>
    <button type="button" class="btn-close" [disabled]="isSending" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">
  <div *ngIf="isLoading" class="text-center py-5">
    <span class="spinner-border spinner-border-sm me-2"></span> Loading {{ label.toLowerCase() }}...
  </div>

  <div *ngIf="loadError" class="alert alert-danger mb-0">{{ loadError }}</div>

  <form *ngIf="!isLoading && !loadError" [formGroup]="form">
    <div *ngIf="!canSendFromStatus" class="alert alert-warning py-2">
      <i class="bi bi-exclamation-triangle me-1"></i>
      This {{ label.toLowerCase() }} is <b>{{ statusLabel(doc?.status) }}</b>. The email can be sent only from: <b>{{ allowedLabels }}</b>.
    </div>

    <div *ngIf="canSendFromStatus && !customerEmails.length" class="alert alert-info py-2">
      <i class="bi bi-info-circle me-1"></i>
      No email address is saved for this customer. Add the recipient below.
    </div>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label font-sb mb-1">Template</label>
        <ng-select [items]="templates" bindLabel="tName" bindValue="templateId" [clearable]="false"
          formControlName="templateId" (change)="onTemplateChange($event?.templateId)" appendTo="body">
        </ng-select>
        <small class="text-muted">Changing the template replaces the subject and body.</small>
      </div>
      <div class="col-md-6">
        <label class="form-label font-sb mb-1">Attachment</label>
        <div class="qep-attachment">
          <i class="bi bi-paperclip me-1"></i>
          <span>The notification service attaches the {{ label.toLowerCase() }} file for <b>{{ doc?.number }}</b> when it sends</span>
        </div>
      </div>

      <div class="col-12">
        <label class="form-label font-sb mb-1">To <span class="text-danger">*</span></label>
        <app-multi-email-input formControlName="to" [suggestions]="customerEmails" [readonly]="!canSendFromStatus"
          placeholder="Type an email and press Enter"></app-multi-email-input>
      </div>
      <div class="col-md-6">
        <label class="form-label font-sb mb-1">CC</label>
        <app-multi-email-input formControlName="cc" [readonly]="!canSendFromStatus"></app-multi-email-input>
      </div>
      <div class="col-md-6">
        <label class="form-label font-sb mb-1">BCC</label>
        <app-multi-email-input formControlName="bcc" [readonly]="!canSendFromStatus"></app-multi-email-input>
      </div>

      <div class="col-12">
        <label class="form-label font-sb mb-1">Subject <span class="text-danger">*</span></label>
        <input type="text" class="form-control form-control-sm" formControlName="subject" maxlength="500"
          [readonly]="!canSendFromStatus"
          [class.is-invalid]="form.controls.subject.touched && form.controls.subject.invalid">
      </div>

      <div class="col-12">
        <label class="form-label font-sb mb-1">Body <span class="text-danger">*</span></label>
        <app-rich-text-editor [control]="form.controls.body"></app-rich-text-editor>
      </div>
    </div>

    <div *ngIf="unresolvedTokens.length" class="alert alert-danger py-2 mt-3 mb-0">
      <i class="bi bi-braces me-1"></i>
      These placeholders have no value for this {{ label.toLowerCase() }}. Replace or remove them before sending:
      <span *ngFor="let t of unresolvedTokens" class="badge bg-danger-subtle text-danger ms-1">{{ t }}</span>
    </div>
  </form>
</div>

<div class="modal-footer justify-content-between">
  <small class="text-muted qep-footnote">
    {{ note }}
  </small>
  <div>
    <button type="button" class="btn btn-sm btn-secondary me-2" [disabled]="isSending" (click)="activeModal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-sm btn-primary" [disabled]="!canSend" (click)="send()">
      <span *ngIf="isSending" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isSending" class="bi bi-send me-1"></i>
      Confirm &amp; Send
    </button>
  </div>
</div>
